var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      










































































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EAnforderung\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cp\u003EDieser Bereich dient dazu, über Ihre Mitarbeiter hinweg alle Dokumente gesammelt abzurufen. Hierfür wählen Sie im Auswahlfeld \"Dokumententyp\" den gewünschten Bereich aus und klicken auf Dokumente anfordern.\u003C\u002Fp\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\" ng-if=\"$ctrl.primary_document_types\"\u003E\u003Cdiv class=\"columns medium-6 medium-offset-3\"\u003E\u003Cdiv\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.model.document_type_selected","title": "Dokumentengruppe","required": pug.escape(true),"attributes": {"ng-options":"tag.name as tag.display for tag in $ctrl.primary_document_types","ng-change":"$ctrl.getComponentsForDocumentType()"},"validationMessages": {"required":"Pflichtfeld"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.secondary_document_types\"\u003E\u003Cdiv class=\"columns medium-6 medium-offset-3\"\u003E\u003Cdiv\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.model.secondary_document_type_selected","title": "Dokumententyp","attributes": {"ng-options":"tag.id as tag.display for tag in $ctrl.secondary_document_types"},"validationMessages": {"required":"Pflichtfeld"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.yearly_sessions &amp;&amp; $ctrl.model.document_type_selected === $ctrl.DOCUMENT_TYPES_BY_NAME['yearly']['name']\"\u003E\u003Cdiv class=\"columns medium-6 medium-offset-3\"\u003E\u003Cdiv\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.model.yearly_session_id","title": "Bezeichnung","required": pug.escape(true),"attributes": {"ng-options":"session._id as $ctrl.getYearlySessionDisplayNameByDates(session.dates) for session in $ctrl.yearly_sessions"},"validationMessages": {"required":"Pflichtfeld"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-show=\"$ctrl.yearly_sessions.length === 0 &amp;&amp; $ctrl.model.document_type_selected === $ctrl.DOCUMENT_TYPES_BY_NAME['yearly']['name']\"\u003E\u003Cp class=\"red medium-offset-3\"\u003EThis customer is not associated with a yearly session.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6 medium-offset-3 center\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.requestDocuments()\" ng-disabled=\"!$ctrl.canRequestDocuments()\"\u003EAbruf absenden\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.forms.documents_request_form"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003Eeingereichte Abrufe\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EDie Abrufe werden über Nacht automatisiert verarbeitet und ein ZIP-Datei generiert. Die bereitgestellte Datei steht dann 7 Tage zum Download bereit.\u003C\u002Fp\u003E\u003Cdiv class=\"list-box\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-5\"\u003E\u003Cdiv\u003EDokumententyp\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cdiv\u003EAnfragedatum\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cdiv\u003EStatus\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cdiv ng-repeat=\"document_request in $ctrl.document_requests\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-5 contract-data\"\u003E\u003Cspan\u003E{{ $ctrl.DOCUMENT_TYPES_BY_NAME[document_request.document_type]['display'] }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!!document_request.secondary_document_type\"\u003E\u003Cspan ng-if=\"document_request.document_type === $ctrl.DOCUMENT_TYPES_BY_NAME['neo']['name']\"\u003E{{' (' + $ctrl.COMPONENTS_WITH_DOCUMENTS_BY_ID[document_request.secondary_document_type]['display'] + ')'}}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"document_request.document_type === $ctrl.DOCUMENT_TYPES_BY_NAME['bonus']['name']\"\u003E{{' (' + $ctrl.BONUS_COMPONENTS_WITH_DOCUMENTS_BY_ID[document_request.secondary_document_type]['display'] + ')'}}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{document_request.created_at*1000 | date: 'dd.MM.yyyy H:mm'}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ $ctrl.DOCUMENTS_DOWNLOAD_REQUEST_STATE_BY_ID[document_request.state].display }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3 contract-data\"\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline\" ng-if=\"$ctrl.DOCUMENTS_DOWNLOAD_REQUEST_STATE_BY_ID[document_request.state].eligible_for_download\" ng-click=\"$ctrl.downloadDocuments(document_request)\"\u003EDownload\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.createDocumentZip(document_request)\"\u003ECreate zip\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;